import { useState, useEffect } from "react";

import {
  Box,
  useColorModeValue,
  Text,
  Button,
  Flex,
  Portal,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  List,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Input,
  VStack,
  IconButton,
} from "@chakra-ui/react";

import { FiBell, FiUser, FiX, FiTrash2 } from "react-icons/fi";

import { SidebarContext } from "contexts/SidebarContext";

import React from "react";

import Loader from "components/Loader";
import HistoryItem from "../../admin/checkDownloadData/components/HistoryItem";
import Navbar from "components/navbar/NavbarAdmin.js";

import Card from "components/card/Card";

import Nft1 from "../../../assets/Rectangle.svg";

import { handleRemoveFile } from "helper/UploadFilePageHelper";

import ModalAllPages from "components/pdf/ModalAllPages";
import { useNavigate } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar.js";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import routes from "routes.js";

import {
  setUploadFileModule_Data,
  setUploadFileModule_Files,
  setSelectedModules,
  setSelectedModuleID,
} from "redux/slice/uploadFileModule";

import { useDispatch } from "react-redux";
import pdf1 from "assets/pdfs/contracts/SARAH WILLIAMS.pdf";
import pdf2 from "assets/pdfs/contracts/SOPHIA HARRIS - PHSP Agreement.pdf";
// Demo mode: no backend required
// import { supabase } from "supabase/supabaseClient";
// import { selectUserData } from "redux/selectorFunctions";
// import { useSelector } from "react-redux";

import { SubfolderItem } from "views/upload/components/SidebarFolder";

import { useLocation } from "react-router-dom";

import TableComponent from "./components/TableComponent";
import DummyPDF from "assets/dummy-11.pdf";
// import SarahWilliamsContract from "assets/SARAH WILLIAMS CONTRACT 1.pdf";

// const api_url = process.env.REACT_APP_API;

export default function ModuleFilesUploadPage() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadloading, setUploadLoading] = useState(false);
  const { onOpen } = useDisclosure();

  const [showFilePreview, setShowFilePreview] = useState(false);
  const [filePreview, setFilePreview] = useState(null);

  const [folderData, setFolderData] = useState(null);

  const [selectedDocumentTypeID, setSelectedDocumentTypeID] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);

  const [selectFolderDrwerOpen, setSelectFolderDrwerOpen] = useState(false);

  const [selectedFolder, setSelectedFolder] = useState(null);

  const [savedJobs, setSavedJobs] = useState(null);

  const [tabIndex, setTabIndex] = useState(1);

  const [jobName, setJobName] = useState("");

  const handleTabsChange = (index) => {
    setTabIndex(index);
  };

  const location = useLocation();

  // Use useEffect to check for state on component mount
  useEffect(() => {
    // If navigation state is missing, fall back to demo defaults
    if (
      !location.state ||
      !location.state.selectedDocumentTypeID ||
      !location.state.selectedDocumentType
    ) {
      const demoDoc = {
        id: 5,
        name: "Private Health Services Plan Agreement",
        description: "Private Health Services Plan Agreement",
        location: "",
        isActive: true,
      };
      setSelectedDocumentTypeID(5);
      setSelectedDocumentType([demoDoc]);
      getSavedJobs(5);
    } else {
      setSelectedDocumentTypeID(location.state.selectedDocumentTypeID);
      // Always ensure selectedDocumentType is an array
      const docType = Array.isArray(location.state.selectedDocumentType)
        ? location.state.selectedDocumentType
        : [location.state.selectedDocumentType];
      setSelectedDocumentType(docType);
      getSavedJobs(location.state.selectedDocumentTypeID);

      // Check if pre-populated files were passed in the navigation state
      if (
        location.state.prePopulatedFiles &&
        location.state.prePopulatedFiles.length > 0
      ) {
        setFiles(location.state.prePopulatedFiles);
      }
    }
  }, [location, navigate]);

  async function getSavedJobs(module_type_id) {
    // Demo: no DB. Provide an empty list or some mock saved jobs if desired.
    const demoSavedJobs = [];
    setSavedJobs(demoSavedJobs);
    setLoading(false);
  }

  const handleClick = () => {
    // Ensure we have files; if not, seed with demo files
    const ensuredFiles =
      files.length > 0
        ? files
        : [
            {
              file_name: "SARAH WILLIAMS.pdf",
              file_type: "application/pdf",
              file_path: "/assets/pdfs/contracts/SARAH WILLIAMS CONTRACT.pdf",
            },
            {
              file_name: "SOPHIA HARRIS – PHSP Agreement.pdf",
              file_type: "application/pdf",
              file_path:
                "/assets/pdfs/contracts/SOPHIA HARRIS - PHSP Agreement.pdf",
            },
          ];
    setFiles(ensuredFiles);

    const baseRows = [
      {
        CPT_Code: "64732",
        Description: "Transection or avulsion of; supraorbital nerve",
        Rate: "$257",
        Effective_Date: "March 10, 2018",
        Provider_Name: "SARAH WILLIAMS",
        Submit_Claims: "45 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between LMN Health Systems, LLC, a Texas limited liability company, ("Network/Payer") and SARAH WILLIAMS, M.D. ("Physician") having FEIN: OPQ6789 effective March 10, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than forty-five (45) days after the date of service. Network shall not be obligated to pay any such bills submitted after the forty-five (45) day period.",
        tax_id: "666543210",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "29705",
        Description: "Removal or bivalving; full arm or full leg cast",
        Rate: "$58",
        Effective_Date: "March 10, 2018",
        Provider_Name: "SARAH WILLIAMS",
        Submit_Claims: "45 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between LMN Health Systems, LLC, a Texas limited liability company, ("Network/Payer") and SARAH WILLIAMS, M.D. ("Physician") having FEIN: OPQ6789 effective March 10, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than forty-five (45) days after the date of service. Network shall not be obligated to pay any such bills submitted after the forty-five (45) day period.",
        tax_id: "666543210",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "27327",
        Description:
          "Excision, tumor, soft tissue of thigh or knee area, subcutaneous; less than 3 cm",
        Rate: "$351",
        Effective_Date: "March 10, 2018",
        Provider_Name: "SARAH WILLIAMS",
        Submit_Claims: "45 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between LMN Health Systems, LLC, a Texas limited liability company, ("Network/Payer") and SARAH WILLIAMS, M.D. ("Physician") having FEIN: OPQ6789 effective March 10, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than forty-five (45) days after the date of service. Network shall not be obligated to pay any such bills submitted after the forty-five (45) day period.",
        tax_id: "666543210",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "20520",
        Description:
          "Removal of foreign body in muscle or tendon sheath; simple",
        Rate: "$317",
        Effective_Date: "March 10, 2018",
        Provider_Name: "SARAH WILLIAMS",
        Submit_Claims: "45 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between LMN Health Systems, LLC, a Texas limited liability company, ("Network/Payer") and SARAH WILLIAMS, M.D. ("Physician") having FEIN: OPQ6789 effective March 10, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than forty-five (45) days after the date of service. Network shall not be obligated to pay any such bills submitted after the forty-five (45) day period.",
        tax_id: "666543210",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97001",
        Description: "Physical therapy evaluation",
        Rate: "$49.43",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97003",
        Description: "Occupational therapy evaluation",
        Rate: "$53.52",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97012",
        Description:
          "Application of a modality to one or more areas; traction, mechanical",
        Rate: "$10.36",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97110",
        Description:
          "Therapeutic procedure, one or more areas, each 15 minutes; therapeutic exercises to develop strength and endurance, range of motion and flexibility",
        Rate: "$20.15",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97140",
        Description:
          "Manual therapy techniques (e.g., mobilization/ manipulation, manual lymphatic drainage, manual traction), 1 or more regions, each 15 minutes",
        Rate: "$18.83",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97530",
        Description:
          "Therapeutic activities, direct (one-on-one) patient contact by the provider (use of dynamic activities to improve functional performance), each 15 minutes",
        Rate: "$21.91",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97035",
        Description:
          "Application of a modality to one or more areas; ultrasound, each 15",
        Rate: "$8.29",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
      {
        CPT_Code: "97014",
        Description:
          "Application of a modality to one or more areas; electrical stimulation (unattended)",
        Rate: "$9.67",
        Effective_Date: "August 15, 2018",
        Provider_Name: "SOPHIA HARRIS",
        Submit_Claims: "110 days",
        cob_provision:
          "Coordination of Benefits (COB). To the extent otherwise permitted in this Agreement, the Provider may participate in collection of COB on behalf of the MCO, with COB collectibles accruing to the MCO or to the provider. However, with respect to enrollees eligible for medical assistance, or participating in Child Health Plus or Family Health Plus, the Provider shall maintain and make available to the MCO records reflecting COB proceeds collected by the Provider or paid directly to enrollees by third party payers, and amounts thereof, and the MCO shall maintain or have immediate access to records concerning collection of COB proceeds.",
        participating_lines_of_business:
          "Provider and Affiliated Providers agree to provide Health Care Services to Enrollees for the Healthfirst plan(s) indicated below. L MEDICAID 2. CHILD HEALTH PLUS PLAN 3. FAMILY HEALTH PLUS PLAN",
        provider_manual_applicability_description:
          "Provider shall be paid the lesser of Provider's billed charges or the amount set forth in the fee schedule established by Healthfirst from time to time, a representative sample of which is set forth below. Unless otherwise indicated, the reimbursement shown below based on services provided in the Provider's office. Reimbursement to Provider shall be subject to the billing requirements, exclusions and limitations set forth in the Provider Manual.",
        provider_name_effective_date:
          'THIS AGREEMENT is entered into by and between MNO Health Management, LLC, a North Carolina limited liability company, ("Network/Payer") and SOPHIA HARRIS, M.D. ("Physician") having FEIN: LOK7890 effective August 15, 2018',
        submit_claims_description:
          "If Physician bills Network, such bill must be submitted no later than one hundred and ten (110) days after the date of service. Network shall not be obligated to pay any such bills submitted after the one hundred and ten (110) day period.",
        tax_id: "654321098",
        created_on: "2023-10-12T12:55:40.263Z",
      },
    ];

    const demoTableData = baseRows;
    const demoFilesForCheck = ensuredFiles.map((f) => ({ name: f.file_name }));

    dispatch(setUploadFileModule_Data(demoTableData));
    dispatch(setUploadFileModule_Files(demoFilesForCheck));
    dispatch(setSelectedModules(selectedDocumentType));
    dispatch(setSelectedModuleID(selectedDocumentTypeID || 5));

    navigate(`/check-data?id=${selectedDocumentTypeID || 5}`, {
      state: {
        table_data: demoTableData,
        files: demoFilesForCheck,
      },
    });
  };

  async function saveJob(module_id, job_data) {
    // Demo: skip persistence
  }

  // ---------------------------
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");

  // function populateSelectFolder() {
  //   // Demo: hardcoded folder structure for the drawer
  //   const demoFolderData = {
  //     sub_folders: [
  //       {
  //         name: "filesUploaded",
  //         folder_contents: ["/assets/dummy-11.pdf", "/assets/dummy-11.pdf", ""],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "PHSP Agreement",
  //         folder_contents: ["/assets/dummy-11.pdf", "/assets/dummy-11.pdf"],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "contractFiles",
  //         folder_contents: ["/assets/dummy-11.pdf"],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "COMBINED FILES",
  //         folder_contents: ["/assets/dummy-11.pdf", "" , "" , "" , "" , "" , "" , ""],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "Assessment Worksheet Form",
  //         folder_contents: ["/assets/dummy-11.pdf"],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "PHSP Agreement",
  //         folder_contents: ["/assets/dummy-11.pdf", "/assets/dummy-11.pdf"],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "Managed Care Contract",
  //         folder_contents: ["/assets/dummy-11.pdf", "/assets/dummy-11.pdf"],
  //         sub_folders: [],
  //       },
  //       {
  //         name: "claimsFiles",
  //         folder_contents: ["/assets/dummy-11.pdf", "/assets/dummy-11.pdf", "/assets/dummy-11.pdf", "/assets/dummy-11.pdf", "/assets/dummy-11.pdf", "/assets/dummy-11.pdf"],
  //         sub_folders: [],
  //       },
  //     ],
  //   };
  //   setFolderData(demoFolderData);
  //   setSelectFolderDrwerOpen(true);
  // }

  const handleFolderClick = (selectedFolder) => {
    setSelectedFolder(selectedFolder);
    const nonEmpty = selectedFolder.folder_contents.filter((str) => str !== "");
    if (nonEmpty.length !== 0) {
      const mapped = nonEmpty.map((path, idx) => ({
        file_name:
          idx === 0
            ? "SARAH WILLIAMS.pdf"
            : "SOPHIA HARRIS – PHSP Agreement.pdf",
        file_type: "application/pdf",
        file_path: path,
      }));
      setFiles(mapped);
      setSelectFolderDrwerOpen(false);
      setLoading(false);
    } else {
      alert("This folder has no files");
    }
  };

  async function getFileContent(file) {
    // Always preview the bundled demo PDF
    setFilePreview(DummyPDF);
    setShowFilePreview(true);
  }

  function viewClick(row_data) {
    dispatch(setUploadFileModule_Files([]));
    dispatch(setUploadFileModule_Data(row_data.original.saved_job));
    navigate(`/check-data?id=${selectedDocumentTypeID}`, {
      state: {
        table_data: row_data.original.saved_job,
        // files: response.data.file_paths,
      },
    });
  }

  async function fetchUploadedFileContent(file_name) {
    console.log(file_name);
    if (file_name === "SARAH WILLIAMS.pdf") {
      setFilePreview(pdf1);
    } else if (file_name === "SOPHIA HARRIS – PHSP Agreement.pdf") {
      setFilePreview(pdf2);
    }
  }
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                      navbarHeading={
                        Array.isArray(selectedDocumentType)
                          ? selectedDocumentType[0]?.module_name ||
                            selectedDocumentType[0]?.name
                          : selectedDocumentType?.module_name ||
                            selectedDocumentType?.name
                      }
                      // {...rest}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box height="85vh" mt={20} rounded={12}>
                    <Tabs isFitted index={tabIndex} onChange={handleTabsChange}>
                      {/* <TabList bg="white" rounded="xl">
                        <Tab>Saved Jobs</Tab>
                        <Tab>Create Job</Tab>
                      </TabList> */}
                      <TabPanels>
                        <TabPanel>
                          <TableComponent
                            columnsData={[
                              {
                                Header: "ID",
                                accessor: "id",
                              },
                              {
                                Header: "NAME",
                                accessor: "job_name",
                              },
                              {
                                Header: "CREATED AT",
                                accessor: "created_at",
                              },
                              // Add more columns as needed
                            ]}
                            tableData={savedJobs}
                            viewClick={viewClick}
                            tableName="Flows"
                          />
                        </TabPanel>
                        <TabPanel>
                          <Flex
                            flexDirection="column"
                            gridArea={{
                              xl: "1 / 3 / 2 / 4",
                              "2xl": "1 / 2 / 2 / 3",
                            }}
                            position="relative"
                            height="100%"
                          >
                            <Card
                              p="0px"
                              height="100%"
                              display="flex"
                              flexDirection="column"
                            >
                              {/* File List */}
                              <Box flex="1" p="22px">
                                <VStack spacing="16px" align="stretch">
                                  {files.map((file, index) => (
                                    <Flex
                                      key={index}
                                      align="center"
                                      bg="gray.50"
                                      p="16px"
                                      borderRadius="12px"
                                      border="1px solid"
                                      borderColor="gray.200"
                                      position="relative"
                                      onClick={() => {
                                        fetchUploadedFileContent(
                                          file.file_name
                                        );

                                        setShowFilePreview(true);
                                      }}
                                    >
                                      {/* File Icon */}
                                      <Box
                                        as="img"
                                        src={Nft1}
                                        alt="file"
                                        boxSize="32px"
                                        mr="16px"
                                        color="blue.500"
                                      />

                                      {/* File Info */}
                                      <Box flex="1">
                                        <Text
                                          fontWeight="medium"
                                          color="gray.700"
                                          fontSize="14px"
                                        >
                                          {file.file_name}
                                        </Text>
                                        {/* <Text
                                          fontSize="12px"
                                          color="blue.500"
                                          cursor="pointer"
                                          mt="4px"
                                        >
                                          Document View
                                        </Text> */}
                                      </Box>

                                      {/* Remove Icon */}
                                      <IconButton
                                        aria-label="Remove file"
                                        icon={<FiX />}
                                        variant="ghost"
                                        size="sm"
                                        onClick={() =>
                                          handleRemoveFile(index, setFiles)
                                        }
                                        color="gray.400"
                                        _hover={{ color: "gray.600" }}
                                        bg="transparent"
                                        borderRadius="full"
                                        w="24px"
                                        h="24px"
                                      />
                                    </Flex>
                                  ))}
                                </VStack>
                              </Box>

                              {/* Bottom Buttons */}
                              <Flex
                                justify="flex-end"
                                p="22px"
                                borderTop="1px solid"
                                borderColor="gray.200"
                                bg="white"
                                borderRadius="0 0 12px 12px"
                              >
                                {/* <Button
                                  width="130px"
                                  // onClick={() => {
                                  //   populateSelectFolder();
                                  // }}
                                  variant="action"
                                >
                                  Select folder
                                </Button> */}
                                {/* <Input
                                  onChange={(e) => {
                                    setJobName(e.target.value);
                                  }}
                                  value={jobName}
                                  width="300px"
                                  variant="outline"
                                  placeholder="Enter job name"
                                /> */}
                                <Button
                                  onClick={handleClick}
                                  colorScheme="blue"
                                  bg="blue.500"
                                  color="white"
                                  borderRadius="8px"
                                  _hover={{ bg: "blue.600" }}
                                >
                                  Extract Data
                                </Button>
                              </Flex>
                            </Card>
                          </Flex>
                        </TabPanel>
                      </TabPanels>
                    </Tabs>

                    {filePreview === null ? (
                      <></>
                    ) : (
                      <ModalAllPages
                        filePreview={filePreview}
                        setShowFilePreview={setShowFilePreview}
                        showFilePreview={showFilePreview}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}

      {folderData ? (
        <Drawer
          isOpen={selectFolderDrwerOpen}
          placement="right"
          onClose={() => {
            setSelectFolderDrwerOpen(false);
          }}
          // finalFocusRef={btnRef}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Select Folder</DrawerHeader>

            <DrawerBody>
              <List spacing={4} mt={5}>
                {folderData.sub_folders.map((subFolder, index) => (
                  <SubfolderItem
                    key={index}
                    subFolder={subFolder}
                    setSelectedFolder={setSelectedFolder}
                    onClick={() => handleFolderClick(subFolder)}
                    level={0}
                    handleFolderClick={handleFolderClick}
                  />
                ))}
              </List>
            </DrawerBody>

            <DrawerFooter>
              <Button
                variant="outline"
                mr={3}
                onClick={() => {
                  setSelectFolderDrwerOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  navigate("/storage-page");
                }}
                colorScheme="blue"
              >
                Add Files
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      ) : (
        <></>
      )}
    </>
  );
}
